import { render, staticRenderFns } from "./PayRangesTable.vue?vue&type=template&id=28189d8a&scoped=true"
import script from "./PayRangesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangesTable.vue?vue&type=style&index=0&id=28189d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28189d8a",
  null
  
)

export default component.exports